import './QuantitativeObjectivesTable.css';

import React from 'react';
import B2BTable from '../../../b2b-common/B2BTable';
import ObjectiveTypeIcon from '../../components/objectives/ObjectiveTypeIcon';
import { toLocaleDateTime } from '../../../b2b-common/helpers';
import { getObjectiveType } from '../../components/objectives/QuantitativeObjectiveEditForm';
import { Add } from '@mui/icons-material';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const QuantitativeObjectivesTable = ({ areaIndicator, onObjectiveClick, onNewObjective }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const headers = [
        { label: t('Type'), align: 'center' },
        { label: t('Start Date'), align: 'center' },
        { label: t('End Date'), align: 'center' },
        { label: t('Start Value'), align: 'left' },
        { label: t('End Value'), align: 'left' },
        { label: t('Samples'), align: 'center' },
    ];

    const rows = areaIndicator ? areaIndicator.objectiveDTOs.map((objective) =>
    ({
        id: objective.objectiveId,
        cells: [
            { content: <ObjectiveTypeIcon objective={objective} showFieldName={false} />, align: 'center' },
            { content: toLocaleDateTime(objective.startDate), align: 'center' },
            { content: toLocaleDateTime(objective.endDate), align: 'center' },
            ...(areaIndicator.indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit !== '' ?
                [{ content: `${objective.startQuantitativeValue} ${areaIndicator.indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit}`, align: 'left' }] :
                [{ content: `${objective.startQuantitativeValue}`, align: 'left' }]),
            ...(getObjectiveType(objective) === 'Regular' || getObjectiveType(objective) === 'Range' ?
                (areaIndicator.indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit !== '' ?
                    [{ content: `${objective.endQuantitativeValue} ${areaIndicator.indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit}`, align: 'left' }] :
                    [{ content: `${objective.endQuantitativeValue}`, align: 'left' }]) : [{ content: '', align: 'left' }]),
            { content: objective.samplesPerObjective.length, align: 'center' },
        ],
    })) : [];

    const handleRowClick = (row) => {
        // console.log('handleRowClick:', row);
        if (onObjectiveClick) {
            onObjectiveClick(areaIndicator.objectiveDTOs.find(objective => objective.objectiveId === row.id));
        }
    };

    return (
        <B2BTable
            headers={headers}
            rows={rows}
            className={'quantitative-objectives'}
            onRowClick={handleRowClick}
            buttons={
                [
                    {
                        label: t('New Objective'),
                        icon: <Add />,
                        onClick: onNewObjective,
                    },
                ]
            }
        />
    );
};

export default QuantitativeObjectivesTable;